<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I want to extend the term of my ebook</h1>
			<p>
				Unfortunately, student E-Books cannot be extended, but you can <a class="help-link" :href="`/book/${isbn}`">buy a new license</a>
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import Axios from 'axios';

	export default {
		name: "WantToExtendTerm",

		components: {
			BaseNavLinks,
		},

		data() {
			return {
				loading: false,
				isbn: null,
			};
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(this.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						self.isbn = response.data['data']['product_isbn'];
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},
	}
</script>

<style scoped>

</style>